import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";

interface WpImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  imageId: number;
}

export const WpImage: React.FC<WpImageProps> = ({imageId, alt = "", ...props}) => {
  const {data} = useQuery(trpc.media.imageUrl.queryOptions({id: imageId}));
  const imageUrl = data?.url;
  const {style, className, ...imgProps} = props;

  return (
    <img
      {...imgProps}
      className={className}
      src={imageUrl}
      alt={alt}
      style={{
        ...style,
        opacity: imageUrl ? 1 : 0,
        transition: "opacity 180ms ease",
      }}
    />
  );
};
